// extracted by mini-css-extract-plugin
module.exports = {"container":"_1idMw","header":"_3xYT7","closeIcon":"_2kexC"};